import React from 'react';
import PropTypes from 'prop-types';
import { Disclosure } from '@headlessui/react';
import DisclosureTagFilterButton from './DisclosureTagFilterButton';
import DisclosureFilterCount from '../../pages/people-partners/DisclosureFilterCount';
import _ from 'lodash';

DisclosureFilter.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltip: PropTypes.string,
  value: PropTypes.array,
  children: PropTypes.node,
  count: PropTypes.number,
  defaultOpen: PropTypes.bool,
};

export default function DisclosureFilter(props) {
  const {
    label,
    tooltip,
    value = [],
    count,
    defaultOpen,
    children
  } = props;

  const numberSelected = count ?? _.compact(value).length;
  const isDefaultOpen = defaultOpen ?? numberSelected > 0;

  return (
    <Disclosure as="div" defaultOpen={isDefaultOpen}>
      {({ open }) => (
        <>
          <DisclosureTagFilterButton
            // label={numberSelected ? `${label} (${numberSelected})` : label}
            label={(
              <span className="flex items-center text-left space-x-2">
                <span>
                  {label}
                </span>
                <DisclosureFilterCount
                  count={numberSelected}
                />
              </span>
            )}
            tooltip={tooltip}
            open={open}
          />
          <Disclosure.Panel className="px-4 py-4 space-y-4">
            {children}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};
